module.exports = __webpack_public_path__ + "img/det2.b5ed7abe.png";